class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".js-load-more");
    this.nextPageURL = this.button?.dataset?.nextPage;
    this.button?.addEventListener("click", this.getNextPage.bind(this));
    this.productGrid = document.querySelector(".js-collection-product-grid");
  }

  getNextPage() {
    fetch(this.nextPageURL)
      .then(response => response.text())
      .then(responseText => {
        const newProductGrid = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.js-collection-product-grid').innerHTML;
        const newLoadMore = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector(".js-collection-load-more")

        this.productGrid.insertAdjacentHTML("beforeend", newProductGrid);
        if (newLoadMore) {
          this.productGrid.insertAdjacentElement("afterend", newLoadMore);
        }
        this.remove();
        refreshYotpoWidgets();
      })
  }
}

customElements.define("load-more", LoadMore);
